<div [formGroup]="clientInvoiceDraftForm" class="grid template-cols-36 gap-24 client-invoice-draft-item">
  <div class="g-col-1 k-d-flex k-align-items-center" style="width: 32px;">
    @if(!disabled()) {
    <kendo-dropdownbutton
      class="no-bg-dropdown"
      iconClass="rc-icon-vertical-dots"
      [data]="menuItems"
      (itemClick)="onActionMenuItemClick($event)">
    </kendo-dropdownbutton>
    }
  </div>
  <div class="g-col-4 k-d-flex k-align-items-center">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-textbox
        #articleNumber
        rcValidation
        [rcDisabled]="true"
        formControlName="articleNumber" />
    </kendo-formfield>
  </div>

  <div class="g-col-6 k-d-flex k-align-items-center">
    <div class="k-d-flex k-flex-column k-w-full">
      <kendo-formfield showHints="initial" showErrors="initial">
        <div
          #cmbWrapper
          class="cmb-with-icon"
          [style.--textWidth.px]="getTextPixelWidth(clientInvoiceDraftItem().typeNumber, cmbWrapper)"
          [class.show-custom-article-icon-icon]="!clientInvoiceDraftItem().supplierArticle && articleCmb.value"
        >
          @let supplierArticles = supplierArticles$ | async;
          <kendo-combobox
            #articleCmb
            rcValidation
            formControlName="supplierArticle"
            [data]="getData(supplierArticles)"
            [filterable]="true"
            [kendoDropDownFilter]="filterSettings"
            [textField]="'code'"
            [valueField]="'@id'"
            [valuePrimitive]="true"
            [allowCustom]="!clientInvoiceDraftItem().supplierArticle || getData(supplierArticles).length === 0"
            (filterChange)="filterArticles($event)"
            (selectionChange)="onArticleSelectionChange($event)"
            (blur)="updateSupplierArticle()"
            (keydown.enter)="articleCmb.handleBlur()"
          >
          </kendo-combobox>
          <i
            class="custom-article-icon rc-icon-package-off fc-accents-red-500"
            attr.aria-label="{{ 'ARTICLE_OUT_OF_CATALOGUE' | translate | capitalize }}"
            routerLinkActive="primary-nav__link--active"
            kendoTooltip
            [showOn]="'hover'"
            title="{{ 'ARTICLE_OUT_OF_CATALOGUE' | translate | capitalize }}"
            position="bottom"></i>
        </div>
      </kendo-formfield>
    </div>
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-numerictextbox
        #retailPrice
        rcValidation
        [format]="decimalFormat"
        [spinners]="false"
        [changeValueOnScroll]="false"
        (blur)="updateRow('retailPrice')"
        formControlName="retailPrice"></kendo-numerictextbox>
    </kendo-formfield>
  </div>

  <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
    <span>{{ clientInvoiceDraftItem().vatPercentage | percentage }}</span>
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    @if (amountReadOnly()) {
      {{ clientInvoiceDraftItem().amount | kendoNumber: amountFormat }}
    } @else {
      <kendo-formfield showHints="initial" showErrors="initial">
        <kendo-numerictextbox
          #amount
          rcValidation
          [format]="amountFormat"
          [decimals]="amountDecimals"
          [max]="max()"
          [spinners]="false"
          [autoCorrect]="true"
          [changeValueOnScroll]="false"
          (blur)="updateRow('amount')"
          formControlName="amount"></kendo-numerictextbox>
      </kendo-formfield>
    }
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-numerictextbox
        [format]="decimalFormat"
        [spinners]="false"
        [changeValueOnScroll]="false"
        [decimals]="2"
        rcValidation
        formControlName="taxPrice"
        (blur)="updateRow('taxPrice')">
      </kendo-numerictextbox>
    </kendo-formfield>
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
    @if (clientInvoiceDraftItem().supplierArticle) {
      {{ clientInvoiceDraftItem().basicNetPrice | kendoNumber: decimalFormat }}
    } @else {
      <kendo-formfield showHints="initial" showErrors="initial">
        <kendo-numerictextbox
          #basicNetPrice
          rcValidation
          [format]="decimalFormat"
          [decimals]="2"
          [spinners]="false"
          [changeValueOnScroll]="false"
          (blur)="updateRow('basicNetPrice')"
          formControlName="basicNetPrice"></kendo-numerictextbox>
      </kendo-formfield>
    }
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-start">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-textbox
        rcValidation
        class="text-align-left"
        formControlName="conditionString"
        (blur)="updateRow('conditionString')"></kendo-textbox>
    </kendo-formfield>
  </div>

  <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
    <kendo-formfield showHints="initial" showErrors="initial">
      <kendo-numerictextbox
        [format]="decimalFormat"
        [spinners]="false"
        [changeValueOnScroll]="false"
        [decimals]="2"
        rcValidation
        formControlName="purchasePrice"
        (blur)="updateRow('purchasePrice')">
      </kendo-numerictextbox>
    </kendo-formfield>
  </div>

  <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
    {{ clientInvoiceDraftItem().lineTotal | kendoNumber: decimalFormat }}
  </div>

</div>
